/*!
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import Moment from 'moment';
import OfferDetailsHeader from "./OfferDetailsHeader";
import {OFFER_DETAILS} from "../../constants/constants";
import {Select} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import {OfferDetailsDatePicker} from "./OfferDetailsDatePicker";


export default class ProductOfferDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {reloadKeyForDateChange: 0,};
        this.handleCourseCopyableChange = this.handleCourseCopyableChange.bind(this);
        this.handleSelectOnChange = this.handleSelectOnChange.bind(this);
    }
    static get propTypes() {
        return {
            productDetails: PropTypes.array.isRequired,
            offerDetails: PropTypes.array.isRequired,
            updateCopyableStatus: PropTypes.func,
            updateProductStage:PropTypes.func,
            guardDirtySetActive: PropTypes.func,
            registrarCourseSectionDetails: PropTypes.array.isRequired,
            hasPrivateResources:PropTypes.bool,
            updateOffer: PropTypes.func
        };
    }
    componentDidMount() {
        this.props.getProductDetails(this.props.match.params.collId);
        this.props.getOfferDetails(this.props.match.params.collId);  
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("ProductDetails");
        }
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("offerDetails");
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const isRender = prevProps.offerDetails && prevProps.offerDetails._embedded && prevProps.offerDetails._embedded.offers.some((offer, index) => {
            return offer.offerEndDate !== this.props.offerDetails._embedded.offers[index].offerEndDate;
        });
        if (isRender) {
            this.setState((state) => {
                return { reloadKeyForDateChange: state.reloadKeyForDateChange + 1 };
            });
        }
    }
    handleCourseCopyableChange(e) {
        e.preventDefault();
        this.props.guardDirtySetActive(true);
        this.props.updateCopyableStatus(e.target.value);
        
    }

    handleSelectOnChange(e){
        this.props.guardDirtySetActive(true);
        this.props.updateProductStage(e.target.value);
    }
    offerEndDateChangeHandler = (changeDate, offerId, index, offerDetails) => {
        const offerEndDate = `${Moment(changeDate).format("YYYY-MM-DD")}T00:00:00.000Z`;
        this.props.guardDirtySetActive(true);
        this.props.updateOffer({ offerEndDate, offerId, index });
        this.setState((state) => {
            return { reloadKeyForDateChange: state.reloadKeyForDateChange + 1 };
        });
    }
 
    render() {
        const {productDetails, offerDetails} = this.props;
        const isOfferEndDateDisabled = (this.props.productDetails.productStage === 'RETIRED') || (this.props.hasPrivateResources) ? true : false ; 

        let isCopyable = `${productDetails.courses && productDetails.courses.isCopyable}`;
        let productStage = `${productDetails.productStage}`;
        return (
            <div className="pe-row product-details-container">
                <div className="product-details-page product-details">
                    <div className='pe-row'>
                        <div className="pe-col-12">
                            <div className='header-margin' >
                                <label className="pe-title--small">PDZ details</label>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='pe-row'>
                            <div className="pe-col-1">
                                <label className="pe-label--bold">ProductID</label>
                            </div>
                            <div className="row productid">
                                <label className="pe-label">{productDetails.productId}</label>
                            </div>
                        </div>
                        <div className='pe-row'>
                            <div className="pe-col-6">
                                <div className="order-info">
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Title</label>
                                        </div>
                                        <div className="row title">
                                            <label className="pe-label">{productDetails.name}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">ImageURL</label>
                                        </div>

                                        <div className="row imageurl-Path">
                                            <label className="pe-label"><a href="#">{productDetails.images && productDetails.images.catalogUrl}</a></label>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Product Stage</label>
                                            <div className="row">
                                                { (productDetails.productStage !== '') &&<select id="productStage" className="product"
                                                    onChange={this.handleSelectOnChange}
                                                    value = {productStage}>
                                                    <option  value={'ACTIVE'}> ACTIVE </option>
                                                    <option  value={'RETIRED'}> RETIRED </option>
                                                </select>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Manifest File Path</label>
                                        </div>
                    
                                    </div>
                                    <div className="row manifest-Path">
                                        <label className="pe-label"><a href="#">{productDetails.manifestFilePath}</a></label>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Content Published Date</label>
                                        </div>
                    
                                    </div>
                                    <div className="row content-publish-date">
                                        <label className="pe-label">{moment.utc(productDetails.contentPublishedDate).format('YYYY-MM-DD')}</label>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">ContentBuild Index Consumed Date</label>
                                        </div>
                                    </div>
                                    <div className="row content-publish-date">
                                        <label className="pe-label">{moment.utc(productDetails.dateContentBuildIndexConsumed).format('YYYY-MM-DD')}</label>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Content Index Build ID</label>
                                        </div>
                                        <div className="row institution-name">
                                            <label className="pe-label">{productDetails.contentIndexBuildId}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Content Ingestion Status</label>
                                        </div>
                                        <div className="row content-status">
                                            <label className="pe-label">{JSON.stringify(productDetails.contentIngestionComplete)}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Content Index Status</label>
                                        </div>
                                        <div className="row content-status">
                                            <label className="pe-label">{JSON.stringify(productDetails.contentIndexBuildComplete)}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Content TOC Processing Status</label>
                                        </div>
                                        <div className="row content-status">
                                            <label className="pe-label">{JSON.stringify(productDetails.tableOfContentsProcessingComplete)}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">PLA Seeding Status</label>
                                        </div>
                                        <div className="row content-status">
                                            <label className="pe-label">{JSON.stringify(productDetails.contentSeedComplete)}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Hide In Marketplace Status</label>
                                        </div>
                                        <div className="row content-status">
                                            <label className="pe-label">{JSON.stringify(productDetails.hideInMarketplace)}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Course Copyable</label>
                                        </div>
                                        <div className="row">
                                            {(isCopyable != undefined && isCopyable !== '') && <select id="courseCopyable" className="select-data" 
                                                onChange={this.handleCourseCopyableChange}
                                                value = {isCopyable}>
                                                <option  value={'true'}> true </option>
                                                <option  value={'false'}> false </option>
                                            </select>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col1">
                                            <label className="pe-label--bold">Course Editable</label>
                                        </div>
                                        <div className="row content-status">
                                            <label className="pe-label">{JSON.stringify(productDetails.editable)}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
                <br></br>
                <div className='offer-details-page'>
                    <div className='pe-row'>
                        <div className="pe-col-12">
                            <div className='header-margin' >
                                <label className="pe-title--small">Offer Details</label>
                            </div>
                        </div>
                    </div>
                    {offerDetails && offerDetails._embedded && offerDetails._embedded.offers.map((offers,index)=> (<OfferDetailsHeader key={`offers_${index}`} offerDetails={offers}>
                        <div className="offer-details">
                            <div className="pe-row">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.TITLE} </label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label">{offers.title}</label>
                                </div>
                            </div>
                            <div className="pe-row">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.SUBSCRIPTION_DURATION}</label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label first-charupper">{offers.offerType.definition.subscriptionDuration}</label>
                                </div>
                            </div>
                            <div className="pe-row alignitem-center">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.PRODUCT_ID}</label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label">{offers.productId}</label>
                                </div>
                            </div>
                            <div className="pe-row">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.SOURCE_SYSTEM} </label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label">{offers.sourceSystem}</label>
                                </div>
                            </div>
                            <div className="pe-row">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.DATE_CREATED}</label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label">{offers.dateCreated}</label>
                                </div>
                            </div>
                            <div className="pe-row">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.REPUBLISHED}</label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label">{JSON.stringify(offers.republished)}</label>
                                </div>
                            </div>
                            <div className="pe-row">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.OFFER_ID}</label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label">{offers.offerId}</label>
                                </div>
                            </div>
                            <div className="pe-row">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.PRICE}</label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label">{offers.offerType.definition.price}</label>
                                </div>
                            </div>
                            <div className="pe-row">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.CURRENCY}</label>
                                </div>
                                <div className="pe-col-6">
                                    <label className="pe-label">{offers.offerType.definition.currency}</label>
                                </div>
                            </div>
                            <div className="pe-row alignitem-center">
                                <div className="pe-col-6">
                                    <label className="pe-label--bold">{OFFER_DETAILS.OFFER_END_DATE}</label>
                                </div>
                                <div className="pe-col-4">
                                    <OfferDetailsDatePicker options={{ offers, index, offerEndDateChangeHandler: (cd, fid, idx) => this.offerEndDateChangeHandler(cd, fid, idx, offerDetails) }} key={this.state.reloadKeyForDateChange} DateDisabled ={isOfferEndDateDisabled}/>
                                </div>
                            </div>
                        </div>
                    </OfferDetailsHeader>))}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ProductOfferDetails.js